import { Component, Input, OnInit } from '@angular/core';
import { Link } from '../../models/link.interface';

@Component({
  selector: 'app-links-preview',
  templateUrl: './links-preview.component.html',
  styleUrls: ['./links-preview.component.scss'],
})
export class LinksPreviewComponent implements OnInit {
  @Input() links?: Link[] = [];

  get leftItems() {
    return this.links?.filter((element, index) => {
      return index % 2 === 0;
    });
  }

  get rightItems() {
    return this.links?.filter((element, index) => {
      return index % 2 === 1;
    });
  }

  constructor() { }

  ngOnInit(): void {
  }

}
